'use strict';
import {assignAssetToModel} from '../../app/model/actions';
import {TOAST_TYPES} from '../../forms/enums/ToastTypes';


AssetsCreateController.$inject = [
  '$scope',
  '$miscUtils',
  '$ngRedux',
  '$contextMenu',
  '$toast',
  'AssetDomain',
  '$modal',
];

export function AssetsCreateController(
  $scope,
  $miscUtils,
  $ngRedux,
  $contextMenu,
  $toast,
  AssetDomain,
  $modal,
) {
  const vm = $scope.createAsset = this;

  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = $miscUtils.blockPromise(cancel);

  vm.model = AssetDomain.$factory.create();
  vm.assetEditor = {};


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function save() {
    return vm.assetEditor.save().then(withNewAsset);
  }

  function cancel() {
    return $modal.hide();
  }

  function withNewAsset(asset) {
    $toast.showMessage('New Asset Saved!', null, TOAST_TYPES.info);// TODO(i18n): convert to message code
    $ngRedux.dispatch(assignAssetToModel(asset));
    return $modal.hide(asset);
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}



// WEBPACK FOOTER //
// ./src/js/assets/controllers/AssetsCreateController.js